import { render, staticRenderFns } from "./ReportsDeliverySatisfactionSurveyHistoryView.vue?vue&type=template&id=5fcf33c8"
import script from "./ReportsDeliverySatisfactionSurveyHistoryView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySatisfactionSurveyHistoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports